import { formatISO } from 'date-fns';

import { HistoryDatepickerWithModal } from 'reusable/historyDatepickerWithModal/HistoryDatepickerWithModal';
import { TableSearchContainer } from 'reusable/tableSearch/TableSearchContainer';
import { HistoryActionAutocomplete } from 'reusable/historyActionAutocomplete/HistoryActionAutocomplete';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { UserPermissionsHistoryQuery } from 'context/query/queryContext/QueryContext.types';
import { QueryKeyLocalStorageEnum } from 'context/query/queryContext/QueryContext.enum';

import { UserPermissionsHistoryFiltersProps } from './UserPermissionsHistoryFilters.types';

export const UserPermissionsHistoryFilters = ({
  userSearchQuery,
  setUserSearchQuery,
}: UserPermissionsHistoryFiltersProps) => {
  const { formatMessage } = useLocale();

  const {
    storedQueries: { userPermissionsHistory: userPermissionsHistoryQuery },
    setQuery,
  } = useLocaleStoreQuery();

  const setHistoryQuery = (query: UserPermissionsHistoryQuery) => {
    setQuery(QueryKeyLocalStorageEnum.USER_PERMISSIONS_HISTORY, { ...userPermissionsHistoryQuery, ...query });
  };

  return (
    <>
      <HistoryDatepickerWithModal
        dates={[
          userPermissionsHistoryQuery.dataOd ? new Date(userPermissionsHistoryQuery.dataOd) : null,
          userPermissionsHistoryQuery.dataDo ? new Date(userPermissionsHistoryQuery.dataDo) : null,
        ]}
        setDates={(dates) =>
          setHistoryQuery({
            dataOd: dates[0] ? formatISO(dates[0]) : undefined,
            dataDo: dates[1] ? formatISO(dates[1]) : undefined,
          })
        }
      />

      <HistoryActionAutocomplete
        selectedAction={userPermissionsHistoryQuery.akcja}
        onChangeAction={(action) => setHistoryQuery({ akcja: action })}
        historyType="user"
      />

      <TableSearchContainer
        withoutToggle
        inputPlaceholder={formatMessage({ id: AppMessages['permissions.history.filters.executor'] })}
        searchBy="users"
        tableSearchQuery={userSearchQuery}
        setTableSearchQuery={setUserSearchQuery}
        selectedValue={userPermissionsHistoryQuery.query}
        setSelectedValue={(option) => setHistoryQuery({ query: option || undefined })}
        inputSize="big"
      />
    </>
  );
};
